import React from "react";
import { Box, Divider, Typography } from "@mui/material";
import styles from "../../assets/styles/loan.module.css";
import Strings from "../../utils/stringUtil";
import AppIcons from "../../utils/appIcons";
import { applyForLoanSteps } from "../../utils/businessLoanUtil";
import { isMobile } from "../../utils/responsiveUtil";

function HowToApply() {
  return (
    <Box className={`container`}>
      <Box
        style={{ transform: "scale(0.92)" }}
        className={styles.flexColumnCenter}
        pt="40px"
      >
        <Typography className={styles.loanTitle}>
          {Strings.howToApply}
        </Typography>

        <Box
          mt={isMobile ? "40px" : "80px"}
          display={"flex"}
          flexDirection={"column"}
          alignItems={"center"}
          position={"relative"}
        >
          <Box display={"flex"} justifyContent={"center"} width={"100%"}>
            <img
              src={AppIcons.imgYellowStar}
              className={styles.rightYellowStar}
              width={32}
              height={32}
            />

            <img
              src={AppIcons.imgYellowStar}
              className={styles.leftYellowStar}
              width={32}
              height={32}
            />
            {/* left section */}
            <StepsStack isRightSection={false} />

            {/* divider */}
            <div className={styles.stepsDivider}></div>

            {/* right section */}
            <StepsStack isRightSection={true} />
          </Box>

          <Box className={styles.submitTextBox}>
            {Strings.submitAndWaitForApproval}
          </Box>
        </Box>
      </Box>
    </Box>
  );
}

function StepsStack({ isRightSection }) {
  return (
    <Box
      width={"100%"}
      display={"flex"}
      flexDirection={"column"}
      alignItems={"center"}
      gap={4}
    >
      {applyForLoanSteps.map((steps, itemIndex) => {
        const isValidItem = isRightSection
          ? itemIndex % 2 != 0
          : itemIndex % 2 == 0;
        return (
          <Box
            key={itemIndex}
            width={steps?.imgUrl ? "50%" : "100%"}
            alignSelf={steps?.imgUrl ? "center" : "end"}
          >
            {isValidItem ? (
              steps?.imgUrl ? (
                <img
                  src={steps?.imgUrl}
                  width={steps?.width}
                  height={steps?.height}
                />
              ) : (
                <Box
                  display={"flex"}
                  alignItems={"center"}
                  style={{ direction: isRightSection ? "rtl" : "ltr" }}
                >
                  <Box className={styles.treeItem}>
                    <Typography className={styles.treeItemTitle}>
                      {steps?.title}
                    </Typography>
                    <Typography className={styles.treeItemDesc}>
                      {steps?.desc}
                    </Typography>
                  </Box>
                  <div className={styles.treeItemLine}></div>
                </Box>
              )
            ) : (
              ""
            )}{" "}
          </Box>
        );
      })}
    </Box>
  );
}
export default HowToApply;
